var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFavicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 14,
    fill: "#C6F221"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.9562 23.1322C44.3598 19.1375 40.0818 16.8947 35.6568 16.7301C34.1885 16.6755 33.0225 15.4791 33.0161 14.0097L32.9938 8.65563C32.9892 7.59375 31.6451 7.13592 30.9936 7.97474L17.8923 24.8399C14.2583 29.4504 13.7718 36.0427 17.1484 41.2385C19.7448 45.2332 24.0232 47.4756 28.4478 47.6406C29.9161 47.6951 31.0825 48.8915 31.0885 50.3606L31.1112 55.715C31.1154 56.7769 32.4595 57.2344 33.111 56.3959L46.2123 39.5304C49.8459 34.9199 50.3331 28.328 46.9562 23.1322Z",
    fill: "#014751"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.98a59e8ddb5f76f1c9ee87c06ecb9fbe.svg";
export { ForwardRef as ReactComponent };